"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useTableSchema_1 = require("./useTableSchema");
function useTablesList() {
    const { tablesList, loading, error } = useTableSchema_1.useTableSchema();
    return {
        tablesList,
        loading,
        error,
    };
}
exports.useTablesList = useTablesList;
//# sourceMappingURL=useTablesList.js.map